import { render, staticRenderFns } from "./term-and-condition-partial.vue?vue&type=template&id=0ac6f344"
import script from "./term-and-condition-partial.vue?vue&type=script&lang=js"
export * from "./term-and-condition-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports